<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>
<p *ngIf="!accounts && !loading"><em>Sem dados</em></p>

<div class="containerSearchTxtOrder" style="margin-bottom: 7px; margin-top: -9px;">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: pointer; cursor: pointer; height: 24px; width: 24px; cursor: inherit; margin-right: 15px;" src="/update.svg" />
  </button>

  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading">
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; margin-right: 5px;" src="/search.svg" />
  </button>

  <!-- Selecione se deve apresentar contas com solicitação de exclusão -->
  <mat-form-field class="select-form account-removal-filter">
    <mat-label [ngClass]="{'account-removal-filter-red': hasRemovalAccount>0}">Contas com solicitação de exclusão{{hasRemovalAccount ? "  ("+hasRemovalAccount+")" : ""}}</mat-label>
    <mat-select matInput name="accountDeletedFilter" [(value)]="accountDeletedSelected" class="filter-field">
      <mat-option (click)="changeAccountBlocked(null)" [value]="">não aplicar</mat-option>
      <mat-option (click)="changeAccountDeleted(1)" [value]="1">Em analise de exclusão de conta</mat-option>
      <mat-option (click)="changeAccountDeleted(0)" [value]="0">Solicitações recusadas</mat-option>
      <mat-option (click)="changeAccountDeleted(3)" [value]="3">Solicitações aceitas</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Selecione se deve apresentar contas bloqueados ou não -->
  <mat-form-field class="select-form account-blocked-filter">
    <mat-label>Contas bloqueadas</mat-label>
    <mat-select matInput name="accountBlockedFilter" [(value)]="accountBlockedSelected" class="filter-field">
      <mat-option (click)="changeAccountBlocked(null)" [value]="">não aplicar</mat-option>
      <mat-option (click)="changeAccountBlocked(true)" [value]="true">sim</mat-option>
      <mat-option (click)="changeAccountBlocked(false)" [value]="false">não</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Selecione se deve apresentar contas suspeitas de fraude-->
  <mat-form-field class="select-form account-suspected-fraud-filter">
    <mat-label>Contas com suspeita de fraude</mat-label>
    <mat-select matInput name="accountSuspectedFraudFilter" [(value)]="accountSuspectedFraudSelected" class="filter-field">
      <mat-option (click)="changeAccountSuspectedFraud(null)" [value]="">não aplicar</mat-option>
      <mat-option (click)="changeAccountSuspectedFraud(true)" [value]="true">sim</mat-option>
      <mat-option (click)="changeAccountSuspectedFraud(false)" [value]="false">não</mat-option>
    </mat-select>
  </mat-form-field>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="CPF/CNPJ/NOME/Número AX" />
</div>

<table class='table table-striped table-without-width table-with-minwidth' aria-labelledby="tableLabel" align="center">
  <thead>
    <tr>
      <th>Nome</th>
      <th style="text-align:center;">CPF/CNPJ</th>
      <th style="text-align:center;">Número AX</th>
      <th style="text-align:center;">E-mail</th>
      <th style="text-align:center;">Bloqueado</th>
      <th style="text-align:center;">Data de Criação</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of accounts | paginate: { id: 'accountPage', itemsPerPage: pageSize, currentPage: page, totalItems: total }; let iS = index">
      <td title="{{ item.name }}">{{ item.name }}</td>
      <td style="text-align:center;" title="{{ item.login }}">{{ item.login }}</td>
      <td style="text-align:center;" title="{{ item.clienteIdAX }}">{{ item.clienteIdAX }}</td>
      <td style="text-align:center;" title="{{ item.email }}">{{ item.email }}</td>
      <td style="text-align:center;" title="{{ item.blocked | BoolToAffirmation }}">{{ item.blocked | BoolToAffirmation }}</td>
      <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>

      <td class="txt-action">
        <button class="btn btn-img-nocircle details btn-detail" [disabled]="loading" (click)="openmodalDetail('modalDetail', $event, item)"></button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="11">
        <pagination-controls id="accountPage"
                             (pageChange)="pageChanged($event)"
                             (pageBoundsCorrection)="pageChanged($event)"
                             maxSize="9"
                             directionLinks="true"
                             autoHide="true"
                             responsive="true"
                             previousLabel="anterior"
                             nextLabel="próximo"
                             screenReaderPaginationLabel="Paginação"
                             screenReaderPageLabel="pagina"
                             screenReaderCurrentLabel="você esta na página">
        </pagination-controls>
      </td>
    </tr>
  </tfoot>
</table>

<div class="modal" id="modalDetail" role="dialog" *ngIf="accountSelected">
  <div class="modal-dialog modal-dialog-blocked">
    <div class="modal-content modal-content-blocked">
      <div class="modal-header">
        <h3>Conta</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalDetail')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Dados da conta</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Nome</mat-label>
              <input matInput value="{{accountSelected.name}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>CPF/CNPJ</mat-label>
              <input matInput value="{{accountSelected.login}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Número AX</mat-label>
              <input matInput value="{{accountSelected.clienteIdAX}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>E-mail</mat-label>
              <input matInput value="{{accountSelected.email}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Bloqueado</mat-label>
              <input matInput value="{{ accountSelected.blocked | BoolToAffirmation }}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Data de Criação</mat-label>
              <input matInput value="{{ accountSelected.creationDate | date:'dd/MM/yyyy HH:mm' }}" disabled>
            </mat-form-field>

          </mat-card-content>
        </mat-card>
        <br />

        <!--Lista de solicitações de exclusão-->
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Solicitações de exclusão</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <table class='table table-striped' aria-labelledby="tableLabel" align="center">
              <thead>
                <tr>
                  <th style="text-align:center;">Protocolo</th>
                  <th style="text-align:center;">Motivo da exclusão</th>
                  <th style="text-align:center;">Situação</th>
                  <th style="text-align:center;">Resolução</th>
                  <th style="text-align:center;">Data de solicitação</th>
                  <th style="text-align:center;">Data ultima atualização</th>
                  <th style="text-align:center;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of removalsAccount; let i = index">
                  <td style="text-align:center;" title="{{ item.protocol }}">{{ item.protocol }}</td>
                  <td style="text-align:center;" title="{{ item.reasonName }}">{{ item.reasonName }}</td>
                  <td style="text-align:center;" title="{{ item.statusName }}">{{ item.statusName }}</td>
                  <td style="text-align:center;" title="{{ item.resolution }}">{{ item.resolution }}</td>
                  <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;" title="{{ item.lastUpdateDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.lastUpdateDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;">
                    <button *ngIf="i===0" class="btn btn-outline btn-grid-line" [disabled]="loading" (click)="accountChangeResolution('modalRemoval', $event, item)">alterar</button>
                  </td>
                </tr>
              </tbody>
            </table>

          </mat-card-content>
        </mat-card>
        <br />

        <!--Lista de devices-->
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Informação de dispositivos já utilizados</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <table class='table table-striped' aria-labelledby="tableLabel" align="center">
              <thead>
                <tr>
                  <th style="text-align:center;">Sistema operacional</th>
                  <th style="text-align:center;">Modelo</th>
                  <th style="text-align:center;">Id do dispositivo</th>
                  <th style="text-align:center;">Bloqueado</th>
                  <th style="text-align:center;">Removido</th>
                  <th style="text-align:center;">Criado</th>
                  <th style="text-align:center;">Contas que conectaram<br>no aparelho</th>
                  <th style="text-align:center;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of accountSelected.accountDevices;">
                  <td style="text-align:center;" title="{{ item.so }}">{{ item.so }}</td>
                  <td style="text-align:center;" title="{{ item.model }}">{{ item.model }}</td>
                  <td style="text-align:center;" title="{{ item.deviceUniqueId }}">{{ item.deviceUniqueId }}</td>
                  <td style="text-align:center;" title="{{ item.blocked | BoolToAffirmation }}">{{ item.blocked | BoolToAffirmation }}</td>
                  <td style="text-align:center;" title="{{ item.deletionDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.deletionDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;">
                    <button *ngIf="item.customers.length > 0" class="btn btn-outline btn-grid-line" [disabled]="loading" (click)="accountInDevice('modalCustomers', $event, item.customers)">ver contas</button>
                  </td>

                  <td class="txt-action">
                    <button *ngIf="item.deletionDate == null && item.blocked && currentUser.userPermission.account.write" class="btn btn-outline btn-grid-line" [disabled]="loading" (click)="blockAccount('modalAlert', $event, item, false)">Liberar</button>
                    <button *ngIf="item.deletionDate == null && !item.blocked && currentUser.userPermission.account.write" class="btn btn-outline btn-grid-line btnCancel" [disabled]="loading" (click)="blockAccount('modalAlert', $event, item, true)">Bloquear</button>
                  </td>
                </tr>
              </tbody>
            </table>

          </mat-card-content>
        </mat-card>
        <br />

        <!--Lista de pedidos-->
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Pedidos</mat-card-title>
          </mat-card-header>
          <mat-card-content>


            <table class='table table-striped' aria-labelledby="tableLabel" align="center" *ngIf="accountOrderSelected && accountOrderSelected.listOrderTracking">
              <thead>
                <tr>
                  <th style="text-align:center;">Pedido</th>
                  <th style="text-align:center;">Data/Hora</th>
                  <th style="text-align:center;">Status do pedido</th>
                  <th style="text-align:center;">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of accountOrderSelected.listOrderTracking;">

                  <td *ngIf="item.orderNumber.indexOf('APPF_') >= 0" style="text-align:center;" title="{{ item.orderNumber }}">{{ item.orderNumber }}</td>
                  <td *ngIf="item.orderNumber.indexOf('APPF_') == -1" style="text-align:center;" title="{{ item.agroup }}">{{ item.agroup }}</td>

                  <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td style="text-align:center;" title="{{ item.statusDescription }}">{{ item.statusDescription }}</td>
                  <td style="text-align:center;" title="{{ item.totalValue | currency : 'R$' }}">{{ item.totalValue | currency : 'R$' }}</td>
                </tr>
              </tbody>
            </table>

          </mat-card-content>
        </mat-card>
        <br />

        <!--Informações adicionais-->
        <mat-card class="card-order-blocked">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Informações adicionais</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <table class='table table-striped' aria-labelledby="tableLabel" align="center">
              <thead>
                <tr>
                  <th style="text-align:center;">Propriedade</th>
                  <th style="text-align:center;">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of accountSelected.accountProperties;">
                  <td style="text-align:center;" title="{{ item.property }}">{{ item.property }}</td>
                  <td style="text-align:center;" title="{{ item.value }}">{{ item.value }}</td>
                </tr>
              </tbody>
            </table>

          </mat-card-content>
        </mat-card>

      </div>
      <div *ngIf="!loading && currentUser.userPermission.account.write" class="modal-footer">
        <button *ngIf="accountSelected.blocked" class="btn btn-outline" [disabled]="loading" (click)="blockAccount('modalAlert', $event, null, false)">Liberar conta</button>
        <button *ngIf="!accountSelected.blocked" class="btn btn-outline btnCancel" [disabled]="loading" (click)="blockAccount('modalAlert', $event, null, true)">Bloquear conta</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalCustomers" role="dialog">
  <div class="modal-dialog modal-dialog-confirm">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="!changeTo ? 'modal-header-warn' : 'modal-header-alert'">
        <h3>Histórico de usuários que conectaram neste aparelho</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalCustomers')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        
        <table class='table table-striped' aria-labelledby="tableLabel" align="center">
          <thead>
            <tr>
              <th>Nome</th>
              <th style="text-align:center;">CPF/CNPJ</th>
              <th style="text-align:center;">Número AX</th>
              <th style="text-align:center;">Bloqueado</th>
              <th style="text-align:center;">Data de Criação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of accountsByDevice; let iS = index">
              <td title="{{ item.name }}">{{ item.name }}</td>
              <td style="text-align:center;" title="{{ item.login }}">{{ item.login }}</td>
              <td style="text-align:center;" title="{{ item.clienteIdAX }}">{{ item.clienteIdAX }}</td>
              <td style="text-align:center;" title="{{ item.blocked | BoolToAffirmation }}">{{ item.blocked | BoolToAffirmation }}</td>
              <td style="text-align:center;" title="{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}">{{ item.creationDate | date:'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalRemoval" role="dialog" *ngIf="removalAccountSelected">
  <div class="modal-dialog modal-dialog-confirm">
    <div class="modal-content modal-content-removal">
      <div class="modal-header" >
        <h3>Analise de solicitação de exclusão</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalRemoval')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <mat-card class="card-order-blocked">
          <mat-card-content>
            <mat-form-field>
              <mat-label>Motivo da exclusão</mat-label>
              <input matInput value="{{removalAccountSelected.reasonName}}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Data de solicitação</mat-label>
              <input matInput value="{{ removalAccountSelected.creationDate | date:'dd/MM/yyyy HH:mm' }}" disabled>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Data última atualização</mat-label>
              <input matInput value="{{ removalAccountSelected.lastUpdateDate | date:'dd/MM/yyyy HH:mm' }}" disabled>
            </mat-form-field>

            <mat-form-field class="removal-resolution">
              <mat-label>Situação</mat-label>
              <mat-select matInput name="removalAccountStatus" [(value)]="removalAccountSelected.status" class="filter-field">
                <mat-option [value]="1">Analise de exclusão de conta</mat-option>
                <mat-option [value]="0">Recusado</mat-option>
                <mat-option [value]="3">Aceito</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="removal-resolution">
              <mat-label>Resolução</mat-label>
              <textarea rows="6" name="removalAccountResolution" matInput [(ngModel)]="removalAccountSelected.resolution"></textarea>
            </mat-form-field>

          </mat-card-content>
          <mat-card-footer class="modal-footer">
            <button class="btn btn-outline" [disabled]="loading" (click)="sendAnalisyRemovalAccount('modalRemoval', $event)" >Enviar resposta</button>
          </mat-card-footer>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalAlert" role="dialog">
  <div class="modal-dialog modal-dialog-confirm">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="!changeTo ? 'modal-header-warn' : 'modal-header-alert'">
        <h3>Confirmação de analise</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalAlert')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <br />
        <br />
        <h4>{{ textConfirm }}</h4>
        <br />
        <br />
      </div>
      <div *ngIf="!loading" class="modal-footer">
        <button class="btn btn-outline" [disabled]="loading" (click)="setAccountResultFraudAnalysis()">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalError" role="dialog">
  <div class="modal-dialog modal-dialog-alert">
    <div class="modal-content">
      <div class="modal-header modal-header-alert">
        <h3>Confirmação de analise</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalError')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <br />
        <br />
        <h4 *ngFor="let item of textError;">{{ item.code }} : {{ item.message }}</h4>
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
